const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const InfoOutlinedIcon = require("@material-ui/icons/InfoOutlined").default;

const {PAYMENT_METHODS} = require('../../../../../../constants/paymentMethods/');
const {DisplayAmountFCAdmin, DisplayAmountAdmin, DisplayIdAdmin, DisplayDateTimeAdmin, DisplayDataAdmin} = require('../../../../../dumb/DisplayData');
const {pushLocation} = require("../../../../../../router");
const {LINK_ADMIN_TRX} = require("../../../../../../constants/links");

const {openPopupWindow} = require("../../../../../../emitters/popup");
const {AdminTableRow} = require('../../../../TableRow');
const Ripple = require("../../../../Ripple");
const Popup = require("../../../../../dumb/Popup/C");
const {SECONDARY_DATA} = require("../TrxDataDisplay/constants");
const TrxDetailsCol = require("../TrxDataDisplay/components/TrxDetailsCol");
const TrxDetailsItem = require("../TrxDataDisplay/components/TrxDetailsItem");
const TrxDetailsRow = require("../TrxDataDisplay/components/TrxDetailsRow");
const {DisplayDateDetailedAdmin} = require("../../../../DisplayData");
const {DisplayStatusTrx} = require("../../../../StatusDisplay");
const Button = require('../../../../Button/Accept');

module.exports = ({data, index}) => {
  const {
    id,
    transaction_type,
    client_quote_id,
    merchant_id: retailer,
    created_at,
    kind,
    payment_amount: fiat_amount,
    payment_asset: fiat_code,
    account_amount: cc_amount,
    account_asset: cc_code,
    payment_method,
    crypto_symbol,
    customer_email,
    method,
    account_name,
    status,
    emitter,
    showCustomer
  } = data;

  const paymentMethod = PAYMENT_METHODS[payment_method] || {};

  return (
    <AdminTableRow className="f12" onClick={false} index={index}>
      <div className="wmin185 fx1 pl25@d2 tl">
        <div className="fw7">
          {upperFirst(transaction_type || '').replace('_', ' ')}
        </div>
        <div className="mt3 fw4 c717275">
          {paymentMethod.name
            ? paymentMethod.name
            : upperFirst(payment_method || '').replace('_', ' ')
          }
        </div>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{client_quote_id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDataAdmin>{account_name}</DisplayDataAdmin>
      </div>
      <div className="wmin185 fx1">
        <DisplayDateTimeAdmin date={created_at} />
      </div>
      <div className="wmin185 fx1 fw7">
        {fiat_amount && cc_amount ? (
          <DisplayAmountFCAdmin
            fiat={{amount: fiat_amount, symbol: fiat_code}}
            crypto={{amount: cc_amount, symbol: cc_code}}
          />
        ) : fiat_amount
          ? (
            <DisplayAmountAdmin
              amount={fiat_amount}
              symbol={fiat_code}
              type="fiat"
            />
          ) : cc_amount
            ? (
              <DisplayAmountAdmin
                amount={cc_amount}
                symbol={cc_code}
                type="coin"
              />
            ) : '-'
        }
      </div>
      {showCustomer && (
        <div className="wmin185 fx1 bold">
          <DisplayDataAdmin>{customer_email}</DisplayDataAdmin>
        </div>
      )}
      <div className="wmin100">
        <Ripple
          className={`(o7).disabled` + (transaction_type === 'unknown' ? ' disabled' : '')}
          disabled={transaction_type === 'unknown'}
          onClick={() => {
            if (transaction_type === 'payment') {
              emitter.emit(id);
              return;
            }

            return openPopupWindow((setPopupState, popup) => {
              const {close} = popup;

              const type = {
                title: 'Type',
                dataHandler: ({transaction_type, kind}) => (
                  <span>{upperFirst(transaction_type || '').replace('_', ' ')}{kind ? ` (${upperFirst(kind || '').replace('_', ' ')})` : ''}</span>
                ),
              };
              const id = {
                title: 'Id',
                dataHandler: ({id, withdrawal_id}) => (
                  <DisplayIdAdmin>{id || withdrawal_id}</DisplayIdAdmin>
                ),
              };
              const appName = {
                title: 'App Url',
                dataHandler: ({app_name}) => (
                  <span>{app_name}</span>
                ),
              };
              const user = {
                title: 'User',
                dataHandler: ({user_email, account_name}) => (
                  <DisplayDataAdmin>{user_email || account_name}</DisplayDataAdmin>
                ),
              };
              const fiat = {
                title: 'Fiat',
                dataHandler: ({fiat_amount, fiat_code}) => (
                  <DisplayAmountAdmin amount={fiat_amount} symbol={fiat_code} type="fiat" />
                )
              };
              const crypto = {
                title: 'Crypto',
                dataHandler: ({cc_amount, cc_code}) => (
                  <DisplayAmountAdmin amount={cc_amount} symbol={cc_code} type="coin" />
                )
              };
              const createdAt = {
                title: 'Transaction date and time',
                dataHandler: ({created_at}) => <DisplayDateDetailedAdmin date={created_at} />
              };
              const status = {
                title: 'Status',
                dataHandler: ({lifeflow: status, withdrawal_status}) => (status || withdrawal_status)
                  ? (
                    <DisplayStatusTrx status={status || withdrawal_status} />
                  ) : '-',
              };

              const dataParams = {
                withdrawal: [
                  id,
                  type,
                  appName,
                  user,
                  fiat,
                  crypto,
                  createdAt,
                  status
                ],
                chargeback: [
                  id,
                  type,
                  fiat,
                  crypto,
                  createdAt,
                  status
                ],
                balance_adjustment: [
                  id,
                  type,
                  appName,
                  user,
                  crypto,
                  createdAt
                ],
                refund: [
                  id,
                  type,
                  fiat,
                  crypto,
                  createdAt,
                  status
                ]
              }

              const dataDisplay = dataParams[transaction_type] || dataParams['withdrawal'];

              return () => {
                return (
                  <Popup
                    caption={(
                      <div className="layoutRow fhaS fvaC w">
                        <div>Details</div>
                      </div>
                    )}
                  >
                    <TrxDetailsRow className="mt9">
                      {dataDisplay.map((el, id) => (
                        <TrxDetailsCol key={id}>
                          <TrxDetailsItem
                            {...el}
                            data={data}
                          />
                        </TrxDetailsCol>
                      ))}
                    </TrxDetailsRow>
                    <Button className="mt40" onClick={close}>
                      Close
                    </Button>
                  </Popup>
                );
              };
            });
          }}
        >
          <InfoOutlinedIcon />
        </Ripple>
      </div>

      {/*<div className="wmin185 fx1 bold">*/}
      {/*  {paymentMethod.name || method}*/}
      {/*</div>*/}
      {/*<div className="wmin185 fx1 bold">*/}
      {/*  <DisplayStatusTrx status={status} />*/}
      {/*</div>*/}
    </AdminTableRow>
  );
};
